import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {isArray} from 'util';
import {ConstantsProvider} from './constants-provider.service';
import {GenericDataProviderInterface} from '../gem-util/GenericDataProviderInterface';

@Injectable()
export class SchoolTypesProvider implements GenericDataProviderInterface{

    constructor(private _httpClient: HttpClient,
                private constantsService: ConstantsProvider) {
    }

    /**
     * Get boards
     *
     * @returns {Promise<any>}
     */
    fetchDataList(schoolId?): Observable<any> {
        const user = this.constantsService.getAuthenticatedUser() || {};
        // 'api/SchoolTypes/owner/' + user.sub
        return this._httpClient.get(this.constantsService.url + 'api/SchoolTypes' , this.constantsService.getAuthHeaderOption());
    }

    /**
     * Get board
     *
     * @param schoolId
     * @returns {Promise<any>}
     */
    fetchSingle(schoolId): Observable<any> {
        return this._httpClient.get(this.constantsService.url + 'api/SchoolTypes/' + schoolId, this.constantsService.getAuthHeaderOption()).pipe(
            map(result => {
                if (isArray(result)) {
                    result = result[0];
                }

                return result;
            })
        );
    }

    create(data: any): Observable<any> {
        return undefined;
    }

    update(data): Observable<any> {
        return undefined;
    }

}
